module.exports = __webpack_public_path__ + "img/state2.27bd901d.png";